<div class="recipe-progress" *ngIf="recipeEventSummary">
  <div class="caption">
    <small class="text-muted">{{ hasStarted ? queuedLabel : '' }}</small>
    <small class="text-muted">
      {{ statusLabel }}<ng-container *ngIf="statusLabel && countsLabel"> · </ng-container>{{ countsLabel }}
    </small>
  </div>

  <ng-container *ngIf="hasStarted; else notStarted">
    <!-- File ticks, with error ticks drawn over them -->
    <div class="tick-row">
      <button *ngFor="let tick of fileTicks" type="button" class="tick file-tick" [class.merged]="tick.events.length > 1"
        [style.left.%]="tick.position" [matTooltip]="tick.tooltip" matTooltipClass="multiline-tooltip"
        [attr.aria-label]="'Go to ' + tick.tooltip" (click)="selectEvent(tick.events[0].id, $event)"></button>
      <button *ngFor="let tick of errorTicks" type="button" class="tick error-tick" [class.merged]="tick.events.length > 1"
        [style.left.%]="tick.position" [matTooltip]="tick.tooltip" matTooltipClass="multiline-tooltip"
        [attr.aria-label]="'Go to ' + tick.tooltip" (click)="selectEvent(tick.events[0].id, $event)"></button>
    </div>

    <div class="track">
      <ng-container *ngFor="let segment of segments">
        <div *ngIf="!segment.broken" class="segment {{ segment.cssClass }}" [class.running]="segment.running"
          [style.left.%]="segment.left" [style.width.%]="segment.width" [matTooltip]="segment.tooltip"></div>

        <!-- Shortened segment: two halves either side of a slanted gap, like an axis break -->
        <ng-container *ngIf="segment.broken">
          <div class="segment break-before {{ segment.cssClass }}" [matTooltip]="segment.tooltip"
            [style.left.%]="segment.left" [style.width]="'calc(' + segment.width / 2 + '% - 3px)'"></div>
          <div class="segment break-after {{ segment.cssClass }}" [matTooltip]="segment.tooltip"
            [style.left]="'calc(' + (segment.left + segment.width / 2) + '% + 3px)'" [style.width]="'calc(' + segment.width / 2 + '% - 3px)'"></div>
        </ng-container>
      </ng-container>
    </div>

    <!-- Job brackets with their stages nested below; each half jumps to the start or finish event -->
    <div class="job-area" *ngIf="jobs.length" [style.height.px]="jobAreaHeight">
      <ng-container *ngFor="let job of jobs">
        <ng-container *ngTemplateOutlet="bracketTemplate; context: { $implicit: job, stage: false }"></ng-container>
        <ng-container *ngFor="let stage of job.stages">
          <ng-container *ngTemplateOutlet="bracketTemplate; context: { $implicit: stage, stage: true }"></ng-container>
        </ng-container>
      </ng-container>
    </div>

    <ng-template #bracketTemplate let-bracket let-stage="stage">
      <div class="job" [class.stage]="stage" [class.open]="bracket.open" [class.failed]="bracket.failed"
        [style.left.%]="bracket.left" [style.width.%]="bracket.width" [style.top.px]="bracket.top"
        [matTooltip]="bracket.tooltip" matTooltipClass="multiline-tooltip">
        <div class="bracket"></div>
        <small class="job-name">{{ bracket.name }}</small>
        <button type="button" class="job-end start" [disabled]="!bracket.startEventId" [attr.aria-label]="'Go to start of ' + bracket.name"
          (click)="selectEvent(bracket.startEventId, $event)"></button>
        <button type="button" class="job-end finish" [disabled]="!bracket.endEventId" [attr.aria-label]="'Go to finish of ' + bracket.name"
          (click)="selectEvent(bracket.endEventId, $event)"></button>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #notStarted>
    <div class="track waiting"><small class="text-muted">{{ queuedLabel }}</small></div>
  </ng-template>
</div>
